import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AlohaLogo from '../../logos/AlohaLogo304x83.png'

export default function SidebarTopItem() {
  const navigate = useNavigate()

  // ! Temporarily commenting out all the tabs except for Site Readiness (ECS-5373)
  // ! Note: Remove these (!) comments when we reintroduce the pages
  const imageClick = () => navigate('/readiness/')

  return (
    <Stack
      onClick={imageClick}
      sx={{
        paddingX: 1.5,
        paddingY: 4.15,
        marginTop: 0,
        marginBottom: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer'
      }}
    >
      <img
        data-testid="Aloha_logo"
        src={AlohaLogo}
        alt="AlohaUpgrades"
        width={150}
      />

      <Typography
        sx={{
          paddingTop: 1,
          color: '#5F259F',
          fontWeight: 'bold'
        }}
      >
        Solution Upgrades
      </Typography>
    </Stack>
  )
}
